"use client";

import useMeasure from "react-use-measure";

import { Lang } from "@/i18n-config";
import { getTranslations } from "@/utils/i18n/get-translations";

import { NavigationButton } from "./NavigationButton";

interface NavigationButtonGroupProps {
  lang: Lang;
  symbol: string;
  country?: "TW" | "US";
}

export const NavigationButtonGroupRoot = ({
  lang,
  symbol,
  country,
}: NavigationButtonGroupProps) => {
  const { t } = getTranslations(lang);
  const [ref, { width }] = useMeasure();

  return (
    <div ref={ref} className="mt-4 flex gap-2" data-hidden={!width}>
      <NavigationButton href={`/${lang}/my/analysis/${symbol}`}>
        {t.analysis.navigation.layoutNavOverview}
      </NavigationButton>
      <NavigationButton
        href={`/${lang}/my/analysis/${symbol}/ai-view/value`}
        activeMatchLevel={1}
      >
        {t.analysis.navigation.layoutNavAiView}
      </NavigationButton>
      <NavigationButton
        href={`/${lang}/my/analysis/${symbol}/financial-metrics`}
      >
        {t.analysis.navigation.layoutNavFinancialMetrics}
      </NavigationButton>

      {
        country === "US" && null
        // 個股分析 v3 Phase 2 再處理 Stock Sentiment
        // <NavigationButton
        //   href={`/${lang}/my/analysis/${symbol}/stock-sentiment`}
        // >
        //   {t.analysis.navigation.layoutNavStockSentiment}
        // </NavigationButton>
      }
      <NavigationButton href={`/${lang}/my/analysis/${symbol}/whale-interest`}>
        {t.analysis.navigation.layoutNavWhaleInterest}
      </NavigationButton>
      <NavigationButton
        href={`/${lang}/my/analysis/${symbol}/tradingview-advanced-chart`}
      >
        {t.analysis.navigation.layoutNavTradingView}
      </NavigationButton>
    </div>
  );
};
